import getApiConfigBySubdomain from './getApiConfigBySubdomain';

const getApiHost = (
  hostname: Document['location']['hostname'] = document.location.hostname,
) => {
  const [subdomain] = hostname.split('.');

  return (
    getApiConfigBySubdomain(hostname)[subdomain] ||
    ['api', API_HOST || hostname].filter(Boolean).join('.')
  );
};

export const getApiBasePathInfo = (
  { hostname, protocol }: Document['location'] = document.location,
) => {
  const isControl =
    hostname.startsWith('control.') || hostname.startsWith('control-');

  return {
    protocol,
    host: getApiHost(hostname),
    pathname: isControl ? 'control' : 'front',
  };
};

const getApiBasePath = (location: Document['location'] = document.location) => {
  const { protocol, pathname, host } = getApiBasePathInfo(location);

  return `${protocol}//${host}/${pathname}`;
};

export default getApiBasePath;
